import { render, staticRenderFns } from "./i4pro-card-list.vue?vue&type=template&id=612446b2&scoped=true"
import script from "./i4pro-card-list.vue?vue&type=script&lang=js"
export * from "./i4pro-card-list.vue?vue&type=script&lang=js"
import style0 from "./i4pro-card-list.vue?vue&type=style&index=0&id=612446b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612446b2",
  null
  
)

export default component.exports